import { MDBBootstrapModulePro } from './../../libs/mdbootstrap/typescripts/pro/index';
import { MDBBootstrapModule } from './../../libs/mdbootstrap/typescripts/free/index';
import { ProcessService } from './../core/process/process.service';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

import { CoreModule } from '../core/core.module';
import { SharedModule } from '../shared/shared.module';
import { ModalModule } from 'app/modal/modal.module';
import { CreateProcessComponent } from 'app/createProcess/createProcess.component';
import { CreateProcessRoutingModule } from 'app/createProcess/createProcess-routing.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

@NgModule({
  imports: [
    MDBBootstrapModule,
    MDBBootstrapModulePro,
    CommonModule,
    TranslateModule,
    CoreModule,
    SharedModule,
    CreateProcessRoutingModule,
    ModalModule,
    FormsModule,
    ReactiveFormsModule,
  ],
  declarations: [
    CreateProcessComponent
  ],
  providers: [
    ProcessService
  ]
})
export class CreateProcessModule { }



// WEBPACK FOOTER //
// C:/ProactiView/ProactiView-Client/src/app/createProcess/createProcess.module.ts